module.exports = __webpack_public_path__ + "img/choose-up-cresa-disabled.f62e6853.png";